import Vue from "vue";
import Vuex from "vuex";
import measure from "./store/measure";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiUrl: `${process.env.VUE_APP_API_URL}/api/`,
    baseApiUrl: `${process.env.VUE_APP_API_URL}`,
    user: window.localStorage.user ? JSON.parse(window.localStorage.user) : "",
  },
  mutations: {},
  actions: {},
  modules: {
    measure,
  },
});
